import { type EnvConfig } from '@/utils/environment';

const DEFAULT_PROTOCOL = 'http';
const DEFAULT_SUBDOMAIN = 'admin-dev';

/**
 * Resolves the API origin for the host the app is currently served from.
 */
export const getApiBaseUrl = (config: EnvConfig) => {
  const { hostname, origin } = window.location;

  // Envoy sessions belong to the current host. Keep /api on that exact origin,
  // including .admin. company views and local proxy hosts.
  // A full origin is required: Api.ts treats an empty baseURL as uninitialized.
  if (hostname !== 'localhost') {
    return origin;
  }

  // Preserve the configured development API for bare-localhost Vite/test fixtures.
  const domain = config.VITE_API_DOMAIN;
  const protocol = config.VITE_API_PROTOCOL ?? DEFAULT_PROTOCOL;

  return `${protocol}://${DEFAULT_SUBDOMAIN}.${domain}`;
};
